import { useQuery } from "@tanstack/react-query";
import { getCountries } from "@api/v1/methods";
import { PageableRegionList } from "../model";

export const useCountries = () =>
  useQuery<PageableRegionList, Error>({
    queryKey: ["countries"],
    queryFn: getCountries,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
